import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8d7bdca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "amount" }
const _hoisted_3 = { class: "currency" }
const _hoisted_4 = { class: "checkout-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Pay with", -1))
const _hoisted_6 = { class: "checkout-wrap" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

import { ref } from "vue";
import { Radio, RadioGroup, Row, Col, Icon } from "vant";
import { usePayList, usePayTypes, init, submitHandler } from "../model";

// 展开关闭的列表

export default /*#__PURE__*/_defineComponent({
  __name: 'checkoutPc',
  setup(__props) {

const { activeNames, changeOpen } = usePayList()
// 单选框的值
const checkContent = ref<string>("");
// 数据请求初始化
const { order: orderObj, payTypes } = usePayTypes()
init(orderObj, payTypes)

// 按钮步骤
const loading = ref(false)
function submit() {
  submitHandler(checkContent.value, checkContent.value, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_CHLoading = _resolveComponent("CHLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Row), {
      class: "amount-container",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(orderObj).amount), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(orderObj).currencyCode), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Row), {
        class: "checkout-header",
        align: "center"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(RadioGroup), {
          modelValue: checkContent.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkContent).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payTypes), (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_unref(Row), {
                  style: {"cursor":"pointer"},
                  class: "row parent",
                  align: "center",
                  onClick: ($event: any) => (item.childrenList.length ? _unref(changeOpen)(index) : null)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Col), { style: {"width":"40px"} }, {
                      default: _withCtx(() => [
                        (item.childrenList.length)
                          ? (_openBlock(), _createBlock(_unref(Icon), {
                              key: 0,
                              name: _unref(activeNames).includes(index) ? 'arrow-down' : 'arrow'
                            }, null, 8, ["name"]))
                          : (_openBlock(), _createBlock(_unref(Radio), {
                              key: 1,
                              name: item.value
                            }, null, 8, ["name"]))
                      ]),
                      _: 2
                    }, 1024),
                    (item.url)
                      ? (_openBlock(), _createBlock(_unref(Col), {
                          key: 0,
                          style: {"margin-right":"16px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: item.url,
                              style: {"width":"26px"}
                            }, null, 8, _hoisted_7)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(Col), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.mode), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (item.childrenList.length && _unref(activeNames).includes(index))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.childrenList, (childItem, index) => {
                      return (_openBlock(), _createElementBlock("section", {
                        key: index + 'main'
                      }, [
                        _createVNode(_unref(Row), {
                          class: "row child",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Col), { style: {"width":"40px"} }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Radio), {
                                  name: childItem.value
                                }, null, 8, ["name"])
                              ]),
                              _: 2
                            }, 1024),
                            (childItem.url)
                              ? (_openBlock(), _createBlock(_unref(Col), {
                                  key: 0,
                                  style: {"margin-right":"16px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: childItem.url,
                                      style: {"width":"26px"}
                                    }, null, 8, _hoisted_8)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(Col), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(childItem.mode), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_unref(Row), {
      class: "btn-group",
      justify: "center",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "btn",
          onClick: submit
        }, "PAY")
      ]),
      _: 1
    }),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_CHLoading, {
          key: 0,
          text: "Processing"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})